import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {post} from 'bukku/shared/ApiService';

// MPS Login
export function* mpsLoginRequest() {
    yield takeEvery(actions.TEST_MPS_LOGIN_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: 'BUTTON_LOADING' });
            const response = yield call(post, '/test/mps/login', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.TEST_MPS_LOGIN_SUCCESS,
                accessToken: data.access_token,
            });
        }
        catch (error) {
            yield put({
                type: actions.TEST_MPS_LOGIN_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: 'BUTTON_NOT_LOADING' });
        }
    });
}
export function* mpsLoginSuccess() {
    yield takeEvery(actions.TEST_MPS_LOGIN_SUCCESS, () => {});
}
export function* mpsLoginError() {
    yield takeEvery(actions.TEST_MPS_LOGIN_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// MPS Sync
export function* mpsSyncRequest() {
    yield takeEvery(actions.TEST_MPS_SYNC_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: 'BUTTON_LOADING' });
            const response = yield call(post, '/test/mps/sync', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.TEST_MPS_SYNC_SUCCESS,
                invoice: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.TEST_MPS_SYNC_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: 'BUTTON_NOT_LOADING' });
        }
    });
}
export function* mpsSyncSuccess() {
    yield takeEvery(actions.TEST_MPS_SYNC_SUCCESS, () => {});
}
export function* mpsSyncError() {
    yield takeEvery(actions.TEST_MPS_SYNC_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(mpsLoginRequest),
        fork(mpsLoginSuccess),
        fork(mpsLoginError),
        fork(mpsSyncRequest),
        fork(mpsSyncSuccess),
        fork(mpsSyncError),
    ]);
}
